<template>
    <div>
        <div v-if="!articleToEditKey">
            <div class="col-1">
            <h3>Articles</h3>
                <div class="flex">
                    <div style="width:200px;margin-right:10px;">
                        <div class="input-label">Filter by Status</div>
                        <div class="input-box down-caret">
                            <select v-model="filterStatus" label="Status">
                                <option value="draft">draft</option>
                                <option value="publish">published</option>
                                <option value="preview">preview</option>
                            </select>
                        </div>
                    </div>
                    <div style="width:200px;margin-right:10px;">
                        <div class="input-label">Filter by Category</div>
                        <div class="input-box down-caret" v-if="showCategory">
                            <select v-model="filterCategory" @change="updateSubcategories" label="Category">
                                <option
                                v-for="(item,key) in categories"
                                :key="key"
                                :value="item"
                                >{{ item }}</option>
                            </select>
                        </div>
                        <div class="input-box down-caret" v-if="subCategories">
                            <select v-model="filterSubcategory" label="Subcategory">
                                <option
                                v-for="(subitem,subkey) in subCategories"
                                :key="subkey"
                                :value="subitem"
                                >{{ subitem }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="showTags" style="width:200px;margin-right:10px;">
                        <div class="input-label">Filter by Tag</div>
                        <div class="input-box tag-input-container" style="height:auto;">
                            <tag-input :options="tags" placeholder="Enter tag" @value="updateTag" :multiple="false"></tag-input>
                        </div>
                    </div>
                    <div style="margin-right:10px;">
                        <div class="input-label">Article Published</div>
                        <div class="input-box">
                            <md-datepicker v-model="filterByTimestamp" md-immediately />
                        </div>
                    </div>
                    <div>
                        <button @click="clearFilters();" style="margin-top: 20px;height: 30px;">CLEAR FILTERS</button>
                    </div>
                    <div class="flex-1"></div>
                    <div style="width:300px;">
                        <div class="input-label">Search</div>
                        <div class="input-box">
                            <input
                                class="modal-input"
                                v-model="searchTerm"
                                v-on:input="searchForTerm"
                                placeholder="Start typing to search..."
                            >
                        </div>
                    </div>

                </div>
            </div>
        <md-table>
            <md-table-row>
            <!-- <md-table-head>USER ID</md-table-head> -->
            <md-table-head>TITLE</md-table-head>
            <md-table-head>AUTHOR</md-table-head>
            <md-table-head>STATUS</md-table-head>
            <md-table-head>CATEGORY</md-table-head>
            <md-table-head>TAGS</md-table-head>
            <md-table-head>DATE</md-table-head>
            </md-table-row>
            <template v-if="searchResults.length == 0">
                <md-table-row v-for="(item, key) in posts" :key="key" @click="editArticle(item)">
                    <md-table-cell style="min-width:30%;" v-html="item.title"></md-table-cell>
                    <md-table-cell style="width:200px;">{{ item.authorSlug }}</md-table-cell>
                    <md-table-cell style="width:100px;">{{ item.status }}</md-table-cell>
                    <md-table-cell style="width:200px;">{{ item.parentCategory }}{{ item.subCategory ? " | " + item.subCategory : "" }}</md-table-cell>
                    <md-table-cell class="tags" style="min-width:30%;"><span v-for="(tag, tagkey) in item.tags" :key="tagkey">{{ tag }} </span></md-table-cell>
                    <md-table-cell style="width:100px;">{{ $moment(item.timestamp * 1000) | moment("hh:mm DD/MM/YYYY") }}</md-table-cell>
                </md-table-row>
            </template>
            <template v-else>
                <md-table-row v-for="(item, key) in searchResults" :key="key" @click="editArticle(item)">
                    <md-table-cell style="min-width:30%;" v-html="item.title"></md-table-cell>
                    <md-table-cell style="width:200px;">{{ item.author }}</md-table-cell>
                    <md-table-cell style="width:100px;">publish</md-table-cell>
                    <md-table-cell style="width:200px;">{{ item.categories }}</md-table-cell>
                    <md-table-cell class="tags" style="min-width:30%;"><span v-for="(tag, tagkey) in item.tags.split(',')" :key="tagkey">{{ tag }}</span></md-table-cell>
                    <md-table-cell style="width:100px;">{{ $moment(item.timestamp * 1000) | moment("hh:mm DD/MM/YYYY") }}</md-table-cell>
                </md-table-row>
            </template>
        </md-table>
        <button @click="morePosts" style="margin:5px auto;display: block;width:300px;" v-if="posts.length == 20">MORE ITEMS</button>
      </div>
        <div v-else>
            <div>
                <md-button class="md-icon-button md-primary" @click="articleToEditKey = false">
                    <md-icon>arrow_back_ios</md-icon>
                </md-button>
            </div>
            <article-editor ref="editor" @not-found="articleToEditKey = false"></article-editor>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
import pageList from "../widgets/pageList";
import gridX from "../widgets/gridX";
Vue.use(VueFirestore);
Vue.use(require('vue-moment'));
var firestore;
import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";
import config from "../../config.json";
import articleEditor from "../common/articleEditor";
import TagInput from "../common/atoms/TagInput";

export default {
    name: "articles",
    components: {
        pageList,
        TagInput,
        articleEditor,
        gridX,
        "ic-firebase-upload": IcFirebaseUploader
    },
    data () {
        firestore = firebase.firestore();
        return {
            storage: firebase.storage(),
            searchTerm: "",
            searchResults: [],
            articleToEditKey: false,
            tempImage: null,
            filterCategory: null,
            filterSubcategory: null,
            filterTag: null,
            filterStatus: null,
            filterByTimestamp: Date.now(),
            startAfter: null,
            categories: [],
            resetTag: false,
            subCategories: false,
            showCategory: false,
            tags: [],
            showTags: false
        }
    },
    watch: {
        filterCategory: function(val) {
            if(val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterSubcategory: function(val) {
            
            if(val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterTag: function(val) {
            console.log("filterTag",val);
            if(val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterStatus: function(val) {
            console.log("filterStatus",val);
            if(val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterByTimestamp: function(val) {
            if(val == Date.now()) return;
            this.startAfter = parseInt(this.$moment(val).endOf("day").format("X"));
        },
        startAfter: function(val, oldval) {
            if(val) {
                this.updateFilter();
            }
        },
    },
    firestore() {
        return {
        // Collection
            posts: firestore.collection("posts").limit(20).orderBy("timestamp", "desc")
        };
    },
    mounted: function() {
        this.showCategory = false;
        this.showTags = false;
        firestore
        .collection("categories")
        .get()
        .then((querySnap) => {
            querySnap.forEach((catSnap) => {
                this.categories.push(catSnap.id);
            });
            this.showCategory = true;
        });
        firestore
            .collection("tags")
            .get()
            .then((querySnap) => {
                querySnap.forEach((tagSnap) => {
                    this.tags.push(tagSnap.id);
                });
                this.showTags = true;
            });
        var client = algoliasearch(
            "U5GL740LVM",
            "ee79df2ed46df0e29f0a0e05d9d2466f"
        );
        this.algolia = client.initIndex("posts");
    },
    methods: {
        updateTag: function(tag) {
            this.filterTag = tag;
        },
        morePosts: function() {
            this.startAfter = this.posts[this.posts.length-1].timestamp;
            window.scrollTo(0,0);
        },
        clearFilters: function() {
            this.filterSubcategory = false;
            this.filterCategory = false;
            this.filterTag = false;
            this.filterStatus = false;
            this.startAfter = false;
            this.searchTerm = "";
            this.searchResults = [];
            this.showTags = false;
            Vue.nextTick(() => {
                this.showTags = true;
            })
            this.updateFilter();
        },
        updateFilter: function() {
            Vue.nextTick(() => {
                var ref = firestore.collection("posts");
                if(this.filterCategory) ref = ref.where("parentCategory", "==", this.filterCategory);
                if(this.filterSubcategory) ref = ref.where("subCategory", "==", this.filterSubcategory);
                if(this.filterTag) ref = ref.where("tags", "array-contains", this.filterTag);
                if(this.filterStatus) ref = ref.where("status", "==", this.filterStatus);
                
                console.log(this.filterStatus);
                console.log(this.filterCategory);
                console.log(this.filterSubcategory);
                console.log(this.filterTag);
                ref = ref.limit(20).orderBy("timestamp", "desc");
                if(this.startAfter) ref = ref.startAfter(this.startAfter);
                console.log("getting posts!");
                this.$binding("posts", ref);
            });
        },
        updateSubcategories: function() {
            this.subCategories = null;
            console.log(this.filterCategory);
            firestore
                .collection("categories")
                .doc(this.filterCategory)
                .get()
                .then((docSnap) => {
                    var data = docSnap.data();
                    console.log(data);
                    var temp = [];
                    data.subcategories.forEach((subcat) => {
                        temp.push(subcat.name);
                    });
                    
                    Vue.set(this, "subCategories", temp);
                });
        },
        editArticle: function(article) {
            firestore.collection("postContent")
                .where("slug", "==", article.slug)
                .get()
                .then(snap => {
                    var articleData;
                    if(snap.docs && snap.docs[0]) articleData = snap.docs[0].data();
                    else {
                        alert("Couldn't find article in database");
                        return;
                    }
                    this.searchTerm = "";
                    this.searchResults = [];
                    this.articleToEditKey = article['.key'];
                    Vue.nextTick(() => {
                        this.$refs['editor'].loadArticle(this.articleToEditKey);
                    });
                });
        },
        searchForTerm: function() {
            var query = this.searchTerm;
            if(!query) {
                this.searchResults = [];
                return;
            }
            this.algolia
                .search({
                query
                })
                .then(responses => {
                this.searchResults = [];
                var searchResults = [];
                console.log(responses);
                responses.hits.forEach(hit => {
                    if (searchResults.length < 20) {
                    searchResults.push({
                        postid: hit.objectID,
                        slug: hit.slug,
                        image: hit.image,
                        title: hit.title,
                        author: hit.author,
                        tags: hit.tags,
                        timestamp: hit.timestamp,
                        categories: hit.categories
                        
                    });
                    }
                });

                // To avoid DOM redraws repeatedly
                // Is this needed? Is Vue smart enough to not redraw when lots of pushes happen?
                this.searchResults = searchResults;
            });
        }
    }
}
</script>
<style>
.md-field.md-theme-default>.md-icon:after {
    background:transparent !important;
}
tbody {
    font-size:0;
}
tbody > * {
    font-size:initial;
}
</style>
<style scoped>
.md-table-row {
    cursor: pointer;
}
.tags span {
    margin-right:5px;
}
</style>



// WEBPACK FOOTER //
// articleList.vue?16bb68a0